import { RightArrowIcon } from '@jouzen/ecom-components/icons/RightArrowIcon';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { Department } from './types';

export interface DepartmentJobsListProps {
  readonly clearSelectedDepartment: () => void;
  readonly department: Department;
}

const DepartmentJobsList = ({
  clearSelectedDepartment,
  department: { jobs, name },
}: DepartmentJobsListProps) => {
  const t = useTranslations();

  return (
    <div className="py-8" data-cy="career-details">
      <button onClick={clearSelectedDepartment} className="mb-8 text-slate-200">
        &larr; {t('back_to_list')}
      </button>
      <div className="pb-4">
        <Typography Element="h4" variant="h5" weight="light">
          {name} - {t('open_roles')}
        </Typography>
      </div>
      <div className="divide-y divide-sandstone-500 border-t-2 border-b border-sandstone-500">
        {jobs.map((job) => (
          <a
            key={`${job.office.id}-${job.department.id}-${job.id}`}
            href={job.absolute_url}
            target="_blank"
            className={cx(
              'relative block w-full py-6 text-left text-sandstone-500',
              'border-r-0 border-l-0 border-solid border-transparent',
              'flex items-center justify-between',
            )}
            rel="noreferrer"
          >
            <div>
              <Typography
                Element="h5"
                className="text-[1.375rem] lg:text-heading-lg"
                weight="light"
              >
                {job.title}
              </Typography>
              <Typography variant="body-small" className="mt-2">
                {job.location.name}
              </Typography>
            </div>
            <RightArrowIcon />
          </a>
        ))}
      </div>
    </div>
  );
};

export default DepartmentJobsList;
